export default "__VITE_ASSET__BylL6OSC__"